export default {
    DRAFT: 'Draft',
    REVIEW: 'Review',
    APPROVED: 'Approved',
    COMPLETED: 'Completed'
}
